var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiagramSankey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 224H256C271 224 284 216 291 203L369 61C373 53 381 48 390 48H600C604 48 608 44 608 40S604 32 600 32H390C375 32 362 40 355 53L277 195C273 203 265 208 256 208H40C36 208 32 212 32 216S36 224 40 224ZM608 296C608 292 604 288 600 288H40C36 288 32 292 32 296S36 304 40 304H186C195 304 203 309 207 317L285 459C292 472 305 480 320 480H600C604 480 608 476 608 472S604 464 600 464H320C311 464 303 459 299 451L221 309C220 307 219 306 218 304H600C604 304 608 300 608 296Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiagramSankey);
export default __webpack_public_path__ + "static/media/diagram-sankey.a0da5cc81fa2abdd462f85f75096ea08.svg";
export { ForwardRef as ReactComponent };